import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * After feed content loads, scroll to #post-:id when present in the URL hash.
 */
export function useScrollToFeedPostAnchor(ready = true) {
  const location = useLocation();

  useEffect(() => {
    if (!ready) return;
    const hash = location.hash || "";
    if (!hash.startsWith("#post-")) return;
    const id = hash.slice(1);
    let attempts = 0;
    let raf = 0;
    let timer = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }
      attempts += 1;
      if (attempts < 20) {
        timer = window.setTimeout(() => {
          raf = window.requestAnimationFrame(tryScroll);
        }, 50);
      }
    };

    raf = window.requestAnimationFrame(tryScroll);
    return () => {
      window.cancelAnimationFrame(raf);
      window.clearTimeout(timer);
    };
  }, [ready, location.pathname, location.search, location.hash]);
}
